import { modes } from './constants';
import { getMetricUnit } from '@utils/metrics';

const transformData = (data, filters, mode = modes.TRENDS) => {
  const transformedData: any = { threshold_baseline: {}, thresholds: [] };
  transformedData.threshold_baseline = data.threshold_baseline;
  transformedData.thresholds = Object.keys(data.thresholds).map((thresholdKey) => {
    const result: any = {};
    if (mode === modes.FILTERS) {
      result.filter = filters.find((f: any) => f.name === thresholdKey);
    } else {
      result.attribute = thresholdKey;
    }
    return {
      ...result,
      ...data.thresholds[thresholdKey],
    };
  });
  const baseLineMetrics = Object.keys(transformedData.threshold_baseline);
  const contentMetrics = transformedData.thresholds
    .map((threshold: any) => {
      return Object.keys(threshold).filter((key) => key !== 'filter' && key !== 'attribute');
    })
    .flat();
  const allMetrics = [...new Set([...baseLineMetrics, ...contentMetrics])];
  const metricsUnit = allMetrics.reduce((acc, metric) => {
    acc[metric] = getMetricUnit({ metricKey: metric });
    return acc;
  }, {});
  return {
    ...transformedData,
    metricsUnit,
  };
};

export default transformData;
